import { SalesCourseIntakesIntakeDto } from '@wisenet/salesapp-client'
import { createContext, useContext } from 'react'

type IntakeContextProps = {
  additionalIntakes: SalesCourseIntakesIntakeDto[]
  selectedCourseIds: string[]
  additionalIntakesCount: number
  addAdditionalCourses: (item: SalesCourseIntakesIntakeDto, courseGuid: string) => void
  removeAdditionalCourse: (guid: string) => void
}

export const IntakeContext = createContext<IntakeContextProps>({
  additionalIntakes: [],
  addAdditionalCourses: () => {},
  removeAdditionalCourse: () => {},
  additionalIntakesCount: 0,
  selectedCourseIds: [],
})

export const useIntakeContext = () => {
  const context = useContext(IntakeContext)

  if (context === undefined) {
    throw new Error('useFilter must be used within a <Filter /> Component')
  }

  return context
}
